var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.75 2.5H11.25C9.175 2.5 7.5 4.175 7.5 6.25V23.75C7.5 25.825 9.175 27.5 11.25 27.5H18.75C20.825 27.5 22.5 25.825 22.5 23.75V6.25C22.5 4.175 20.825 2.5 18.75 2.5Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3376 6.66406H22.9126C22.7626 6.66406 22.6251 6.66406 22.4751 6.67656C22.4876 6.73906 22.5001 6.80156 22.5001 6.87656V8.75156V21.2516V23.1266C22.5001 23.2016 22.4876 23.2641 22.4751 23.3266C22.6126 23.3391 22.7501 23.3391 22.9126 23.3391H23.3376C26.6626 23.3391 27.5001 22.5016 27.5001 19.1641V10.8391C27.5001 7.50156 26.6626 6.66406 23.3376 6.66406Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.1266V21.2516V8.75156V6.87656C7.5 6.80156 7.5125 6.73906 7.525 6.67656C7.375 6.66406 7.2375 6.66406 7.0875 6.66406H6.6625C3.3375 6.66406 2.5 7.50156 2.5 10.8391V19.1641C2.5 22.5016 3.3375 23.3391 6.6625 23.3391H7.0875C7.2375 23.3391 7.375 23.3391 7.525 23.3266C7.5125 23.2641 7.5 23.2016 7.5 23.1266Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderHorizontal);
export default __webpack_public_path__ + "static/media/slider-horizontal.fec2c9e634a2d66d6c400eb481b8732d.svg";
export { ForwardRef as ReactComponent };